export class UpdoxUser {
  id: number;
  updox_user_id: string = '';
  first_name: string = '';
  last_name: string = '';
  updox_username: string = '';
  updox_password: string = '';
  direct_address: string = '';
  direct_address_local: string = '';
  active: boolean = true;
  user_id: number;
  practice_id: number;

  get is_persisted(): boolean {
    return !!this.id;
  }

  load_from_json(json: any): UpdoxUser {
    if (!json) { return this; }
    this.id = json.id;
    this.updox_user_id = json.updox_user_id || '';
    this.first_name = json.first_name || '';
    this.last_name = json.last_name || '';
    this.updox_username = json.updox_username || '';
    this.direct_address = json.direct_address || '';
    this.direct_address_local = json.direct_address_local || '';
    this.active = json.active !== undefined ? json.active : true;
    this.user_id = json.user_id;
    this.practice_id = json.practice_id;
    return this;
  }

  to_params() {
    return {
      updox_user: {
        updox_user_id: this.updox_user_id,
        first_name: this.first_name,
        last_name: this.last_name,
        updox_username: this.updox_username,
        updox_password: this.updox_password,
        direct_address: this.direct_address,
        direct_address_local: this.direct_address_local,
        active: this.active,
        user_id: this.user_id,
        practice_id: this.practice_id,
      }
    };
  }
}
